module.exports = __webpack_public_path__ + "static/img/about.a1caf74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about.jpg
// module id = UAsQ
// module chunks = 1